import { FC } from 'react'

import { UserContext } from './userContext'
import { UserProviderType } from './userContext.types'

export const UserContextProvider: FC<UserProviderType> = ({
  children,
  ...props
}) => {
  return <UserContext.Provider value={props}>{children}</UserContext.Provider>
}
